import * as deepEqual from "deep-equal";
/** Imports */
import { Component, EventEmitter, Input, OnInit, Output, HostListener, ViewEncapsulation } from "@angular/core";
import { AssetAttributesService } from "../services/asset-attributes.service";
import { AssetDetailService } from "../services/asset-detail.service";
import { AuthenticationService } from "../services/authentication.service";
import { GenericLayerService } from "src/app/services/generic-layer.service";
import { ILayer } from "../interface/layer";
import { IUser } from "../interface/user";
import { QueryBuilderService } from "../services/query-builder.service";
import { QueryBuilderConstants } from "./query-builder-constants";
import { QueryLayersService } from "../services/query-layers.service";
import Swal from "sweetalert2";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { Globals } from "../shared/globals";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
import { EventEmittersService } from "../services/event-emitters.service";
import { GenericMapMethodsService } from "../services/generic-map-methods.service";
import { faCheckCircle, faDownload, faUpload, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { faSave, faPlusSquare, faMinusSquare, faEdit as faPenSquare, faTrashAlt, faCalendarAlt as faCalendar } from "@fortawesome/free-regular-svg-icons";

//Added for visualization layers
import * as xml2js from "xml2js";
import { EsriMapComponent } from "src/app/esri-map/esri-map.component";
import { IDropdownListItem, ILayerDropdownListItem } from "../interface/DropDownListItem";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { UserService } from "../services/user.service";  //added 12/31/25
import { CustomTranslatePipe } from "../shared/custom-translate.pipe";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { DropdownComponent } from "../shared/dropdown/dropdown.component";
import { MatTabsModule } from "@angular/material/tabs";
import { ConfigurableHeaderComponent } from "../shared/configurable-header/configurable-header.component";
import { AngularDraggableModule } from "angular2-draggable";
import { NgClass, NgStyle, NgIf, NgFor, AsyncPipe } from "@angular/common";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";
import { ILayerSelections } from "../interface/selectedSet";
import { IQueryStatement } from "../interface/other";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
/** END */

@Component({
    selector: "sms-query-builder",
    templateUrl: "./query-builder.component.html",
    styleUrls: ["./query-builder.component.scss"],
    styles: [
        `
           :host::ng-deep .ng-select .ng-select-container {
             top: -4px;
             left: -8px;
             border: 0px solid #ccc;
             min-height: 10px;
             height: 26px !important;
           }
           :host::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items {
             background-color: #ffffff !important;
             top: -1px;
             text-align: left;
           }
         `
    ],
    standalone: true,
    imports: [CdkDrag, NgClass, AngularDraggableModule, ConfigurableHeaderComponent, CdkDragHandle, NgStyle, MatTabsModule, DropdownComponent, NgIf, MatFormFieldModule, MatInputModule, FormsModule, MatDatepickerModule, ReactiveFormsModule, MatAutocompleteModule, NgFor, MatOptionModule, MatButtonModule, MatIconModule, MatCheckboxModule, MatSelectModule, MatRadioModule, FontAwesomeModule, AsyncPipe, TranslateModule, CustomTranslatePipe]
})

export class QueryBuilderComponent implements OnInit {

  //Added for ADA
  @HostListener("document:keydown.enter", ["$event"])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.target["type"] === "checkbox" && event.target["id"] === "customCheck1") {
      if ((<HTMLInputElement>event.target).checked) {
        (<HTMLInputElement>event.target).checked = false;
      } else {
        (<HTMLInputElement>event.target).checked = true;
      }
    }
    if (event.target["localName"] === "div" && event.target["id"] === "importFileDiv") {
      let fileElementObj = (<HTMLInputElement>event.target).children[0];    
      (<HTMLInputElement>fileElementObj).click();
    }
  }

  constructor(
    // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
    public objGlobals: Globals,
    public qbService: QueryBuilderService,
    public assetDetailService: AssetDetailService,
    public queryLayersService: QueryLayersService,
    public genericLayerService: GenericLayerService,
    public assetAttributesService: AssetAttributesService,
    public auth: AuthenticationService,
    public translateService: TranslateService,
    public eeService: EventEmittersService,
    public constants: QueryBuilderConstants,
    public genericMapMethodsService: GenericMapMethodsService,
    public esriTools: EsriMapComponent, // Added for visualization layers
    public userService: UserService
  ) {
    this.currentUser = this.auth.currentUserValue;
    this.isFromQB.emit(true);
  }
  
  @Input() Query: any;          // esri Query object used to query data through web map
  @Input() FeatureLayer: any;
  @Input() drawTool: any;
  @Input() all: any;
  @Input() SimpleMarkerSymbol: any;
  @Input() Color: any;
  @Input() SimpleFillSymbol: any;
  @Input() SimpleLineSymbol: any;
  @Input() Graphic: any;
  @Input() GraphicsLayer: any;
  @Input() map: any;
  @Input() QueryTask: any;    // esri object used to define queries
  @Input() queryBuilderTable: any;
  @Input() RelationshipQuery: any;
  @Input() PictureMarkerSymbol: any;
  @Input() webMercatorUtils;
  @Input() Point;
  @Input() graphicsUtils;

  @Output() queryBuilder = new EventEmitter();
  @Output() data = new EventEmitter();
  @Output() closeQueryBuilderEvent = new EventEmitter();
  @Output() selectedOptions = new EventEmitter();
  @Output() indexdata = new EventEmitter();
  @Output() minimize = new EventEmitter();
  @Output() layerIndex = new EventEmitter();
  @Output() indexCV = new EventEmitter();  // Fix for QB cardviewer
  @Output() isFromQB = new EventEmitter();


  public joinTypeDropdown: IDropdownListItem[] = [];
  public distanceDropdown: IDropdownListItem = { value: "Distance", display: "Distance" };  // translations?
  public layerDropdown: ILayerDropdownListItem[] = [];
  public fieldDropdown: IDropdownListItem[] = [];
  public operatorDropdown: IDropdownListItem[] = [];
  public valueDropdown: IDropdownListItem[] = [];

  public joinType: string = "";
  //public layerList: any[] = [];  // replaced by layerDropdown
  public fieldArray: any[] = [];

  public selectedLayer: ILayerDropdownListItem | null = null;
  public allFieldAliases: any;  // for every inventory layer and table
  public selectedField;  
  public operator: string;
  public codedValue: any;

  public filteredCodedValues: any[] = [];
  public ftrLayer;

  
  public yrl

  public queryStatement: IQueryStatement = {} as IQueryStatement;
  public builtQuery: IQueryStatement[] = [];

  public inventoryLayersData: ILayer[] = [] as ILayer[];
  public selectGraphicslayer: any;
  public isRowClicked = false;
  public queryTableRow: any;
  public selectedRow: any;

  //Added for Visualization layers
  visualizationFieldsData: any[] = [];
  selectedVisualizationlyr;
  distanceValue = "";

  codedValueControl = new UntypedFormControl();
  codedValues: any[] = [];
  filteredOptions: Observable<IDropdownListItem[]>;


  event: any;
  eventChecked: any;
  // JIRA ID:-61
  isShown = true; // hidden by default

  public loading = false;
  public centered = true;
  public reportFormatDropdown: IDropdownListItem[] = [];
  public reportValueDropdown: IDropdownListItem[] = [];

  expand = this.translateService.instant("Select.carddisplay.expand");
  minimizeTooltip = this.translateService.instant("Select.carddisplay.minimize");
;
  public querydomain = {};
  public LayersFromServices = [];
  public result: any;
  public selectedLayerFieldAliases: any[] = [];
  public whereExp: any;
  public selectionGraphicsLyr: any;
  public newAttribute: any = {};
  public chkMapExtent = false;
  public loadingQc = false;
  public removeselect = false;
  public closeQueryBuilderDialog = false;
  public currentUser: IUser;
  public selectedSet: ILayerSelections[] = [];
  public selectbehaviorobj;
  public selectBehaveValues: any = [];
  public enableDateTimePicker = false;
  public predefinedQueriesList: any[] | undefined = [];
  public fileName: string;
  public pdfConig: any;
  public reportFormatES: any;
  public savedQueriesList: any[] = [];
  public selectedLoadFile: string;
  public selectedPredefinedQuery: string;
  public selectedObjIdsByMapExtent: number[] = [];
  public reportTypeES: string;
  public showExportPopup = false;
  public tableBody: any;
  public selectedReportType: any;
  public todayDate = new Date();
  public dataLength: any;
  public predefinedSelected = false;
  public multiplePrimaryLayerQuery: any;
  public index: any;
  public firstReport = false;
  public prevSelected: any;
  public createdQuery: any = null;
  public aliasData: any[] = [];
  public clickedValidate = false;
  public clickedRun = false;
  public sqlgetSavedQueries: any[] = [];
  public sqlViewOnMap = false;
  public sqlViewOnExcel = false;
  inBounds = true;
  asstClicked = true;
  public isQueryBuilderMinimized = false;
  private userQueryActionsLyrObj: any;

  //icons
  faPlusSquare = faPlusSquare;
  faPencilSquare = faPenSquare;
  faMinusSquare = faMinusSquare;
  faTrash = faTrashAlt;
  faCalendar = faCalendar;
  faSave = faSave;
  faUpload = faUpload;
  faCheckCircle = faCheckCircle;
  faDownload = faDownload;
  faInfoCircle = faInfoCircle;

  /**Query Creator */
  public sqlResultCount: any;
  public queryValidatedFromServer: any;
  public countWhere = 0;

  /**Save from query table to database */
  public clickedOnSave = true;
 // public count;
  public selectedQueryLayersList: string[] = [];  // array of layer names included in built query

  selectedOpentasksJSON;
  visLayerQueryResults: ILayerSelections[]= [];
  public showCardViewForVisualizationLayer = false;
  filterVisualizationData = false;
  querytableUpdated: any[] = [];
  disableJoinTypeDropdown = true;
  showSaveTools: boolean = false;

  minimizeQueryBuilder() {
    this.isQueryBuilderMinimized = !this.isQueryBuilderMinimized;
    this.minimize.emit(this.isQueryBuilderMinimized);
  }

  ngOnInit() {
    this.selectedQueryLayersList = [];
    //Added for visulization layers
    this.filteredOptions = this.codedValueControl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );

    /** saved queries */
    this.userQueryActionsLyrObj = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.userQueryActionsId);
    this.predefinedQueriesList = this.getPredefinedQueries();
    this.savedQueriesList = this.getSavedQueries("QB");
    this.sqlgetSavedQueries = this.getSavedQueries("QC");
    this.clickedOnSave = true;

    /**Default Behaviour is NEW SELECTION */
    this.selectbehaviorobj = this.FeatureLayer.SELECTION_NEW;

    /**Retain Table Values when QB is closed */
    this.builtQuery = this.queryBuilderTable;

    /** by default first layer */
    this.selectGraphicslayer = this.map.smsLayerdata.graphicLayers[0];

    this.assetAttributesService.getTableAlias().subscribe( (result: any) => {
        this.aliasData = result.features;
        this.inventoryLayersData = this.eeService.userLayers.filter((lyr: ILayer) => lyr.type === "inventory");
        this.initQBServiceVariables();
        this.operatorDropdown = this.constants.getOperators();
        this.joinTypeDropdown = this.constants.getJoinType(); 
        this.layerDropdown = this.qbService.getLayerListDropdownValues();
        this.selectBehaveValues = this.constants.getSelectBehaviorValues();
        this.reportFormatDropdown = this.constants.getReportFormat();
        this.reportFormatES = this.reportFormatDropdown[0].value;   // set the default report format to the first available option.  what does ES stand for?
        this.defaultDropdownValues();
      }
    );

    /**Get Fields for layers */
    this.assetAttributesService.getFieldAlias().subscribe((result: any) => {
      this.allFieldAliases = [];
      result.features.forEach((f) => {
        this.allFieldAliases.push(f.attributes);
      });
      //Jira Id-931
      if (this.selectedLayer != null) {
        //TSDRSAM-1792
        this.selectedLayerFieldAliases = this.allFieldAliases.filter((res) => res.TableName.toLowerCase() === this.selectedLayer!.value.toLowerCase() && res.QueryVisible === 1);
        this.fieldDropdown = this.selectedLayerFieldAliases.map((field) => {
          const dropdownItem: IDropdownListItem = {} as IDropdownListItem;
          dropdownItem.display = this.currentUser.scndLang == false ? field.FieldAlias : field.FieldAlias_SL;
          dropdownItem.value = field.Field;
          return dropdownItem;
        });
      }
      if (this.selectedLayerFieldAliases && this.selectedLayerFieldAliases.length > 0) {
        this.selectedField = this.selectedLayerFieldAliases[0].Field;
      }
    });

  }
  defaultDropdownValues() {
    try {
      this.selectedLayer = this.layerDropdown[0]; //Updated for visualization layers
      //this.layr = this.layerList.filter((astCls) => astCls.Layer === this.selectedLayer?.value); //Updated for visualization layers
      //this.layr = this.layerDropdown.filter((lyr) => lyr.value === this.selectedLayer?.value); 
      this.operator = "=";
    } catch (error) {
      console.error(error);
    }
  }
  initQBServiceVariables() {
    try {
      this.qbService.map = this.map;
      this.qbService.Query = this.Query;
      this.qbService.QueryTask = this.QueryTask;
      this.qbService.RelationshipQuery = this.RelationshipQuery;
      this.qbService.inventoryLayersData = this.inventoryLayersData;
      this.qbService.FeatureLayer = this.FeatureLayer;
      this.qbService.aliasData = this.aliasData;
    } catch (error) {
      console.error(error);
    }
  }
  closeQueryBuilder() {
    try {
      /**Close QUery Builder and retain the avlue of  non cleared data  */
      this.queryBuilder.emit(this.builtQuery);
      this.closeQueryBuilderEvent.emit(false);
      // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
      if (this.selectedSet.length === 0) {
        this.eeService.setEnableSingleClick(true);
        this.genericMapMethodsService.queryBuilderZoomExtent = false;
      }
      // For ADA story - by Subba
      let mainPageTools = document.querySelectorAll('[data-mainPageTabbing="yes"]');
      if (mainPageTools.length > 0) {
        mainPageTools.forEach((element) => {
          if (element.localName === "a") {
            element.setAttribute("tabindex", "0");
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**Query Builder On Change Events */
  onJoinChange(selectedJoinType: string) {
    this.joinType = selectedJoinType;
    //Added for visualization layers
    if (this.joinType == "Distance") {
      if (this.selectedLayer?.isVisualizationLayer) {
        //Allow only asset layers
        for (let i = 0; i < this.layerDropdown.length; i++) {
          const layerData = this.layerDropdown[i];
          this.layerDropdown[i].disabled = true;
          if (!layerData.isVisualizationLayer) {
            this.layerDropdown[i].disabled = false;
          }
        }
      } else {
        //Enable only visualization layers
        for (let i = 0; i < this.layerDropdown.length; i++) {
          const layerData = this.layerDropdown[i];
          this.layerDropdown[i].disabled = false;
          if (layerData.isVisualizationLayer) {
            this.layerDropdown[i].disabled = true;
          }
        }
      }
    } else {
      for (let i = 0; i < this.layerDropdown.length; i++) {
        const layerData = this.layerDropdown[i];
        this.layerDropdown[i].disabled = false;
        if (layerData.disabled) {
          this.layerDropdown[i].disabled = true;
        }
      }
    }
  }
  onLayerChange(selectedLayerValue: string) {  
    try {

      this.selectedLayer = this.layerDropdown.find((lyr) => lyr.value == selectedLayerValue)!;

      // reset field and value
      this.fieldDropdown = [];
      this.selectedField = "";
      this.codedValues = [];
      this.codedValue = null;

      this.selectedVisualizationlyr = this.selectedLayer?.isVisualizationLayer ? selectedLayerValue : "";

      if (this.selectedLayer?.isVisualizationLayer) {
        this.getWMSFieldInfo(selectedLayerValue);
        // .then((res) => {
        //   return [];   // Return an empty array for visualization layers
        // });
      } else {
        // field aliases for the selected layer
        this.selectedLayerFieldAliases = this.allFieldAliases.filter((fa) => (
          fa.TableName.toLowerCase() === this.selectedLayer!.value.toLowerCase() 
          && fa.QueryVisible === 1
          && (fa.TableName !== "Activity" || fa.Field === "Activity")     // Activity is the only releveant field on Activity table
        ));
        this.fieldDropdown = this.selectedLayerFieldAliases.map((fa) => {
          const dropdownItem: IDropdownListItem = {
            display: this.currentUser.scndLang == false ? fa.FieldAlias : fa.FieldAlias_SL,
            value: fa.Field
          };
          return dropdownItem;
        });
      }
      this.selectedField = this.fieldDropdown[0]?.value;  
      this.onFieldChange(this.selectedField);
    } catch (error) {
      console.error(error);
    }
  }

  onFieldChange(selectedFieldValue: string) {
    try {
      this.selectedField = selectedFieldValue;

      // clear remaining query builder inputs
      this.operator = "=";
      this.codedValues = this.filteredCodedValues = [];
      this.codedValue = null;
      this.codedValueControl.setValue(null);
      this.enableDateTimePicker = false;

      if (this.selectedLayer?.isVisualizationLayer) {
        return; // strictly text entry
      }

      // DATE field - based only on field name :(  
      if (this.selectedField.includes("Date") ) {
        this.enableDateTimePicker = true;
      } 

      // USER field
      else if (this.constants.userFields.includes(this.selectedField)) {
        this.userService.getWorkerList(this.currentUser.clientId).subscribe( 
          (result: any) => {
            this.codedValues = this.filteredCodedValues = result.map((worker) => {
              return {name: worker.displayName, code: worker.displayName}
            })
          },
          (error: any) => {
            this.codedValues.push({ name: this.currentUser.displayName, code: this.currentUser.displayName})
            this.filteredCodedValues= this.codedValues;
          }
        );     
      }

      // ACTIVITY field (collect unique domain values from activity subtypes)
      else if (this.selectedField === "Activity") {
        const assetsInQuery = this.assetNamesFromBuiltQuery().names; // this.builtQuery.filter((q) => !["Activity", "Assessment", "Maintenance"].includes(q.layer)).map((q) => q.layer);
        this.selectedLayer?.lyrObj.types.forEach((type) => { 
          if (this.currentUser.assignedAssetClasses.find(ac => ac.name === type.name)   // include only subtypes assigned to the user
              && (assetsInQuery.length===0 || assetsInQuery.includes(type.name))) {     // and, if an asset class has been added to the built query, only for it
            type.domains.Activity.codedValues.forEach((cv) => {
              if (!this.codedValues.some(ad => ad === cv.name)) {
                this.codedValues.push({name: cv.name, id: cv.name, code: cv.code});
              }
            });
          }
        });
        this.codedValues.sort((a, b) => a.name.localeCompare(b.name));
        this.filteredCodedValues = this.codedValues;
      } 

      // Query the selected field object for domain/subtype
      else {        
        const queryTask = new this.QueryTask(this.selectedLayer!.lyrObj.url);
        const query = new this.Query();
        query.where = "1=1";
        query.outFields = [this.selectedField];
        query.returnGeometry = false;
        query.returnDistinctValues = true;
        queryTask.execute(query).then((queryResult) => {

          const selectedFieldDomains = this.selectedLayer!.lyrObj._fields.find((f) => f.name === this.selectedField)?.domain;

          // Domained field
          if (selectedFieldDomains) {
            selectedFieldDomains.codedValues.forEach((codeValue) => {
              this.codedValues.push({ name: codeValue.name, id: codeValue.name, code: codeValue.code });
              this.filteredCodedValues.push({ name: codeValue.name, id: codeValue.name, code: codeValue.code });
            });
          } 

          // Undomained fields - construct coded values as needed
          else {

            // use subtype names
            if (this.selectedField === "AssetSubType") {
              this.selectedLayer?.lyrObj.types.forEach((type) => {
                if ( queryResult.features.find((f) => f.attributes[this.selectedField] === type.id) ) {
                  this.codedValues.push({ name: type.name,id: type.id, code: type.id });
                  this.filteredCodedValues.push({ name: type.name,id: type.id, code: type.id });
                }
              });
            }

            // use asset code domain values from each subtype
            else if (this.selectedField === "AssetCode") {
              this.selectedLayer?.lyrObj.types.forEach((type) => {
                type.domains.AssetCode.codedValues.forEach((code) => {
                  if (queryResult.features.find((f) => f.attributes[this.selectedField] === code.code)) {
                    this.codedValues.push({ name: code.name, id: code.name, code: code.code });
                    this.filteredCodedValues.push({ name: code.name, id: code.name, code: code.code });
                  }
                });
              });
            }

            // else - text field w/o coded values

          }
        });

      }
      return this.codedValues;
    } catch (error) {
      console.error(error);
    }
  }

  customSearchFn(searchValue: string) {
    console.log(searchValue);
    this.filteredCodedValues = this.codedValues.filter((item) => item.name.toLowerCase().includes(searchValue.toLowerCase()));
  }
  //
  onValueChange(value: any) {
    try {
      if (value instanceof Date) {
        const month = value.getMonth();
        this.codedValue = value.getFullYear() + "-" + (month + 1) + "-" + value.getDate();
        this.qbService.selectedDate = value;
      } else {
        this.codedValue = value;
      }
    } catch (error) {
      console.error(error);
    }
  }
  onOperatorChange(selectedOperatorValue: string) {
    this.operator = selectedOperatorValue;
  }
  onFileNameChange(event, queryTool) {
    this.populateQueryTable(this.selectedLoadFile, queryTool);
    this.selectedLoadFile = null;
  }

  assetNamesFromBuiltQuery(): {names: string[], primary: string} {
    const nonAssets = ["Activity", "Assessment", "Maintenance"];
    const parentAndChildAssets = ["Sign", "Light", "Support"];
    const names: string[] = this.builtQuery.filter((statement) => !nonAssets.includes(statement.layer)).map((s) => s.layer);
    let primary: string = "";

    if (this.builtQuery.length > 0) {
      primary = names.length > 0 ? (parentAndChildAssets.includes(names[0])) ? "Support" : names[0] : this.builtQuery[0].layer;
    } else {
      primary = (parentAndChildAssets.includes(this.selectedLayer!.value)) ? "Support" : this.selectedLayer!.value;
    }
    return { names: names, primary: primary };

  }

  selectPredefinedQuery(event, query) {
    try {
      this.eventChecked = event;
      this.multiplePrimaryLayerQuery = query;

      if (query.queryId !== "QRY_11" && query.queryId !== "QRY_10") {
        let queryString = query.queryString;
        const regionData = "Region" + this.currentUser.selectedRegion.regionLevel + "='" + this.currentUser.selectedRegion.regionName + "' AND";
        const splitRes = queryString.split(";");
        splitRes[0] += regionData;
        let newQueryString = [];
        newQueryString = splitRes.join(";");
        queryString = newQueryString;
        newQueryString = [];
        newQueryString.push(query);
        this.parseQuery(newQueryString);
      }
    } catch (error) {
      console.error(error);
    }
  }
  getSavedQueries(queryTool) {
    try {
      const queryList: any[] = [];
      this.qbService.getSavedQuery(this.userQueryActionsLyrObj, this.currentUser, this.Query, this.QueryTask, queryTool).then( (result) => {
        result.features.forEach((qry) => {
            if (qry.attributes.QueryName != null) {
              queryList.push({
                fileName: qry.attributes.QueryName,
                queryString: qry.attributes.Query
              });
            }
          });
      });
      return queryList;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  getPredefinedQueries() {
    try {
      const queryList: any[] = [];
      this.qbService.getPredefinedQueries(this.userQueryActionsLyrObj, this.Query, this.QueryTask).then((result) => {
        result.features.forEach((qry:any) => {
          queryList.push({
            queryId: qry.attributes.QueryID,
            queryString: qry.attributes.Query,
            queryDescription: qry.attributes.QueryDescription
          });
        });
      });
      return queryList;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  addItem() {
    try {

      if (this.validateQueryBuilderForm()) {

        this.queryStatement = {
          joinType: this.builtQuery.length >= 1 ? this.joinType : "",
          layer: this.selectedLayer?.isVisualizationLayer ? this.selectedVisualizationlyr : this.selectedLayer!.value,
          layerDisplay: this.selectedLayer!.display,
          field: this.selectedField,
          fieldDisplay: this.selectedField, // todo store field alias here, and use it in UI   
          operator: this.operator,
          value: this.codedValueControl.value,
          valueDisplay: this.codedValueControl.value  // todo store alias and use it in UI
        }

        if (this.joinType == "Distance") {
          this.queryStatement.joinType = "WITHIN   " + this.distanceValue + "ft";
        }

        if (this.codedValueControl.value instanceof Date) {
          const rawDate = this.codedValueControl.value;
          const formattedDate = rawDate.getMonth() + 1 + "-" + rawDate.getDate() + "-" + rawDate.getFullYear();
          this.queryStatement.value = this.queryStatement.valueDisplay = formattedDate;
        }
        
        if (!this.selectedLayer?.isVisualizationLayer && this.selectedField === "AssetSubType") {
          this.qbService.assetCode = this.codedValues;
        }

        // disable appropriate layer values       
        if (this.selectedLayer?.isVisualizationLayer) {
          this.layerDropdown = this.qbService.getLayerListDropdownValues(this.selectedLayer!.value);
        } else {
          this.layerDropdown = this.qbService.getLayerListDropdownValues(this.assetNamesFromBuiltQuery().primary);
          this.selectedQueryLayersList.push(this.selectedLayer!.value);
        }

        this.joinType = this.joinTypeDropdown[0].value; // 8/18/20 jcc set default Join Type after adding first criteria
        this.disableJoinTypeDropdown = false;
        this.builtQuery.push( { ...this.queryStatement });  // shallow copy

      }
    } catch (error) {
      console.error(error);
    }
  }

  validateQueryBuilderForm(): boolean {
      // join type required for second and subsequent statements
      if (this.builtQuery.length > 0 && !this.joinType) {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.addjointype"));
        return false;
      }
      if (this.joinType == "Distance"){
        // only one distance join allowed
        if (this.builtQuery && this.builtQuery.filter((e) => e.joinType && e.joinType.includes("WITHIN")).length > 0) {
          Swal.fire(this.translateService.instant("Querybuilder.OnlyOneDistanceJoin"));
          return false;
        }
        // distance value must be specified
        if (!this.distanceValue) {
          Swal.fire(this.translateService.instant("Querybuilder.DistanceRequired"));
          return false;
        }
      }
      // required fields
      if (!( (this.selectedVisualizationlyr || this.selectedLayer!.value) 
              && this.selectedField 
              && this.operator 
              && [undefined, null, ""].indexOf(this.codedValueControl.value) === -1 )
          ) {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.enterallvalues"));
        return false; 
      }
      // duplicate statement
      if (this.builtQuery.find((s) => 
          {return ( (this.selectedVisualizationlyr || this.selectedLayer!.value) 
                     && s.field === this.selectedField 
                     && s.operator === this.operator 
                     && s.value === this.codedValueControl.value)
          })) {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.querycannotbesame"));
        return false;
      }
      return true;
  }

  emptySearchFields() {
    this.joinType = "";
    this.selectedLayer = null; //{}; // Added for visualization layers
    this.codedValue = null;
    this.codedValueControl.setValue(null);
    this.operator = "";
    this.selectedField = "";
    this.disableJoinTypeDropdown = true;
  }

  deleteStatement(statementIndex: number) {
    try {
      this.selectedSet = [];

      this.builtQuery.splice(statementIndex, 1);
      if (this.builtQuery.length > 0) {
        this.builtQuery[0].joinType = "";  // no joinType on first queryStatement
      }

      if (this.builtQuery.length === 0) {
        // back to no statements, revert to defaults
        this.emptySearchFields();
        /**Join type should be null */
        this.queryStatement.joinType = "";
        /**Saved Query Filename text box empty */
        this.fileName = "";
        /**Reload all Saved Queries*/
        this.savedQueriesList = this.getSavedQueries("QB");
        this.sqlgetSavedQueries = this.getSavedQueries("QC");
        /*Empty Fields and Values*/

        this.selectedLayerFieldAliases = [];
        this.codedValues = [];
        this.filteredCodedValues = this.codedValues;
        // Cannot edit Hide Button
        this.isRowClicked = false;
        // Clear Prev Selected for Query Behavior
        this.prevSelected = [];
        /**Reload Layers */

        //this.setLayerListDropdown();
        this.layerDropdown = this.qbService.getLayerListDropdownValues();

        // todo: selected layer
        this.selectedLayer = this.layerDropdown[0];
        this.onLayerChange(this.selectedLayer.value); //added 4/26/26 to fix issue: when delete single non-sign statement, value dropdowns don't load

        //Jira Id-931,//TSDRSAM-1792
        this.selectedLayerFieldAliases = this.allFieldAliases.filter((res) => res.TableName.toLowerCase() === this.selectedLayer?.value.toLowerCase() && res.QueryVisible === 1);
        this.fieldDropdown = this.selectedLayerFieldAliases.map((field) => {
          const dropdownItem: IDropdownListItem = {} as IDropdownListItem;
          dropdownItem.display = this.currentUser.scndLang == false ? field.FieldAlias : field.FieldAlias_SL;
          dropdownItem.value = field.Field;
          return dropdownItem;
        });
        this.selectedField = this.selectedLayerFieldAliases[0].Field;
        this.onFieldChange(this.selectedField);

      } else {
        this.qbService.getLayerListDropdownValues(this.builtQuery[this.builtQuery.length - 1].layer);
      }
    } catch (error) {
      console.error(error);
    }
  }
  cleartable() {
    try {
      //this.setLayerListDropdown();
      this.layerDropdown = this.qbService.getLayerListDropdownValues();
      this.distanceValue = "";
      this.emptySearchFields();
      this.builtQuery = [];
      this.selectionGraphicsLyr = this.map.getLayer("sms-selection");
      this.selectionGraphicsLyr.clear();
      this.map.graphics.clear();
      this.selectedSet = [];
      this.data.emit([]);
      //Manikantha V 2/8/2021
      this.eeService.setSelectedFeaturesOnMap([]);
      console.log(1);
      this.eeService.setAssetViewer(false);
      this.eeService.setAssetTable(false);
      //Added for Visualization layers
      this.showCardViewForVisualizationLayer = false;
      console.log("Grid View Close  " + 1);
      this.fileName = "";
      this.selectedLoadFile = "";
      // this.predefinedQuerisList = this.getPredefinedQueries();
      this.isRowClicked = false;
      this.prevSelected = [];
      // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
      this.eeService.setEnableSingleClick(true);
    } catch (error) {
      console.error(error);
    }
  }

  clearPredefinedtable() {
    try {
      this.selectedQueryLayersList = [];
      this.selectionGraphicsLyr = this.map.getLayer("sms-selection");
      this.selectionGraphicsLyr.clear();
      this.map.graphics.clear();
      this.selectedSet = [];
      if (this.joinTypeDropdown.length == 3) {
        this.joinTypeDropdown.splice(2, 1); //Added for visualization layers ... remove Distance join type
      }
      this.data.emit([]);
      //Manikantha V 2/8/2021
      this.eeService.setSelectedFeaturesOnMap([]);
      console.log(2);
      this.eeService.setAssetViewer(false);
      this.eeService.setAssetTable(false);
      console.log("Grid View Close  " + 2);
      this.isRowClicked = false;
      this.prevSelected = [];
      // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
      this.eeService.setEnableSingleClick(true);
    } catch (error) {
      console.error(error);
    }
  }

  setClickedRow(index) {
    try {
      this.index = index;
      // Set Clicked Row
      this.isRowClicked = true;
      // Set all Drop down Values
      //this.selectedLayerFieldAliases = 
      this.onLayerChange(this.builtQuery[index].layer);
      if (this.selectedLayerFieldAliases != null) {
        this.fieldDropdown = this.selectedLayerFieldAliases.map((field) => {
          const dropdownItem: IDropdownListItem = {} as IDropdownListItem;
          dropdownItem.display = this.currentUser.scndLang == false ? field.FieldAlias : field.FieldAlias_SL;
          dropdownItem.value = field.Field;
          return dropdownItem;
        });
      }
      this.codedValues = this.onFieldChange(this.builtQuery[index].field);
      this.filteredCodedValues = this.codedValues;
      console.log(this.codedValues);

      this.selectedLayer = this.layerDropdown.find(lyr => lyr.value === this.builtQuery[index].layer) || {} as ILayerDropdownListItem;
      this.selectedField = this.builtQuery[index].field;

      if (this.enableDateTimePicker) {
        this.codedValue = new Date(this.builtQuery[index].value);
        this.codedValueControl.setValue(new Date(this.builtQuery[index].value));
      } else {
        this.codedValue = this.builtQuery[index].value;
        this.codedValueControl.setValue(this.builtQuery[index].value);
      }

      this.operator = this.builtQuery[index].operator;
      this.joinType = this.builtQuery[index].joinType;
    } catch (error) {
      console.error(error);
    }
  }
  selectbehave(event) {
    try {
      switch (event.target.value) {
        case "New Selection":
          this.selectbehaviorobj = this.FeatureLayer.SELECTION_NEW;
          break;
        case "Add to Selection":
          this.selectbehaviorobj = this.FeatureLayer.SELECTION_ADD;
          break;
        case "Remove from Selection":
          this.selectbehaviorobj = this.FeatureLayer.SELECTION_SUBTRACT;
          break;
      }
    } catch (error) {
      console.error(error);
    }
  }

  buildQuery() {  // called by Query button
    try {
      this.loading = true;
      this.filterVisualizationData = false;

      //Added for visualization layers
      if (this.selectedLayer?.isVisualizationLayer) {
        let isSpatialSearch = this.selectedSet?.length>0 ? true : false;
        let allVisLayerQueries = [];
        let filterCriteria = "";
        let orJoinQueries = "";
        let andJoinQueries = "";
        let noJoinQueries = "";
        let isAssetQuery = true;
        this.builtQuery.forEach((statement: IQueryStatement) => {
          if (isSpatialSearch) {
            if (statement.joinType && statement.joinType.includes("WITHIN")) {
              isSpatialSearch = false;
              isAssetQuery = false;
            }
          } else {
            isAssetQuery = false;
          }

          if (!isAssetQuery) {  // wms layer
            let fieldName = "<ogc:PropertyName>" + statement.field + "</ogc:PropertyName>";
            let fieldValue = "<ogc:Literal>" + statement.value + "</ogc:Literal>";
            let finalQuery="";
            
            if (statement.operator == "=") {
              finalQuery = "<ogc:PropertyIsEqualTo>" + fieldName + fieldValue + "</ogc:PropertyIsEqualTo>";
            } else if (statement.operator == "!=") {
              finalQuery = "<ogc:PropertyIsNotEqualTo>" + fieldName + fieldValue + "</ogc:PropertyIsNotEqualTo>";
            } else if (statement.operator == "<") {
              finalQuery = "<ogc:PropertyIsLessThan>" + fieldName + fieldValue + "</ogc:PropertyIsLessThan>";
            } else if (statement.operator == ">") {
              finalQuery = "<ogc:PropertyIsGreaterThan>" + fieldName + fieldValue + "</ogc:PropertyIsGreaterThan>";
            } else if (statement.operator == "<=") {
              finalQuery = "<ogc:PropertyIsLessThanOrEqualTo>" + fieldName + fieldValue + "</ogc:PropertyIsLessThanOrEqualTo>";
            } else if (statement.operator == ">=") {
              finalQuery = "<ogc:PropertyIsGreaterThanOrEqualTo>" + fieldName + fieldValue + "</ogc:PropertyIsGreaterThanOrEqualTo>";
            } else if (statement.operator == "LIKE") {
              fieldValue = "<ogc:Literal>" + "%" + statement.value + "%" + "</ogc:Literal>";
              finalQuery = "<ogc:PropertyIsLike wildcard='%' singleChar='.' escape='!'>" + fieldName + fieldValue + "</ogc:PropertyIsLike>";
            } //TSDRSAM-1864

            if (statement.joinType == "AND") {
              andJoinQueries = andJoinQueries + finalQuery;
            } else if (statement.joinType == "OR") {
              orJoinQueries = orJoinQueries + finalQuery;
            } else {
              noJoinQueries = finalQuery;
            }
          }
        });
        //append all queries
        filterCriteria = noJoinQueries;
        if (andJoinQueries.length > 0) {
          filterCriteria = "<ogc:And>" + filterCriteria + andJoinQueries + "</ogc:And>";
        }
        if (orJoinQueries.length > 0) {
          filterCriteria = "<ogc:Or>" + filterCriteria + orJoinQueries + "</ogc:Or>";
        }
       
        if (this.map.visualizationLayers) {  // wouldn't not be since this.selectedLayer.isVisualizationLayer===true to get here, right?
          let lyr = this.map.visualizationLayers.find((e) => e.layerName == this.selectedVisualizationlyr || e.originalLayerTitle == this.selectedVisualizationlyr);
            
            //create xml body
            let xmlBody =
              "<wfs:GetFeature\n" +
              ' service="WFS" \n' +
              ' version="1.0.0" \n' +
              '  xmlns:wfs="http://www.opengis.net/wfs"\n' +
              '  xmlns:ogc="http://www.opengis.net/ogc"\n' +
              '  xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"\n' +
              '  xsi:schemaLocation="http://www.opengis.net/wfs\n' +
              '  http://schemas.opengis.net/wfs/1.0.0/WFS-basic.xsd">\n' +
              ' <wfs:Query srsName="EPSG:3857" typeName="' +
              lyr.originalLayerTitle +
              '"> \n' +
              " <ogc:Filter> \n" +
              filterCriteria +
              " \n" +
              "  </ogc:Filter> \n" +
              " </wfs:Query>\n" +
              " </wfs:GetFeature>";
            const lastSlash = lyr.wmsUrl.lastIndexOf("/");
            if (
              lyr.wmsUrl
                .substring(lastSlash + 1)
                .toLowerCase()
                .includes("wms")
            ) {
              let wfsUrl = lyr.wmsUrl.substring(0, lastSlash + 2) + "f" + lyr.wmsUrl.substring(lastSlash + 3); // wms => wfs
              let getFeatures = wfsUrl; // + "?service=WFS&REQUEST=GetFeature&VERSION=1.0.0&typeName=" + lyr.originalLayerTitle + "&Filter=" + filterValue;
              allVisLayerQueries.push(this.eeService.getSelectedWFSData(getFeatures, lyr.originalLayerTitle, true, xmlBody));
            }

        }
        let distanceUnits = "feet";
        let updatedSelectedSet: ILayerSelections[] = [];
        if (allVisLayerQueries.length > 0) {

          // process the vis layer query
          this.all(allVisLayerQueries).then( 
            (visLayersSelectedData) => {

              if (this.selectedSet && this.selectedSet.length > 0) {
                //filter the results of existing query result -- is this related to add/remove select behaviour?? or spatial (distance from) query??
                this.selectedSet.forEach((queryData: ILayerSelections) => {
                  let selectionData = [];
                  let uniqueIds: number[] = [];
                  queryData.Data.forEach((data: any) => {
                    visLayersSelectedData.forEach((visLayerData) => {
                      visLayerData.forEach((dataArray) => {
                        dataArray.Data.forEach((element) => {
                          if (uniqueIds.indexOf(data.attributes.OBJECTID) === -1) {
                            let distance = this.esriTools.geometryEngine.distance(element.geometry, data.geometry, distanceUnits);
                            if (distance && distance <= this.distanceValue) {
                              uniqueIds.push(data.attributes.OBJECTID);
                              selectionData.push(data);
                            }
                          }
                        });
                      });
                    });
                  });
                  updatedSelectedSet.push({ LayerInfo: queryData.LayerInfo, Data: selectionData });
                });
                if (updatedSelectedSet && updatedSelectedSet.length > 0 && updatedSelectedSet[0].Data && updatedSelectedSet[0].Data.length > 0) {
                  this.selectedSet = updatedSelectedSet;
                  this.data.emit(this.selectedSet); // let eeService do this
                  this.eeService.setSelectedFeaturesOnMap(this.selectedSet);
                  this.genericMapMethodsService.queryBuilderZoomExtent = true;
                //  this.eeService.setAssetViewer(true);
                } else {
                  this.selectedSet = [];
                  this.data.emit(this.selectedSet);  // let eeService do this
                  this.eeService.setSelectedFeaturesOnMap(this.selectedSet);
                  this.genericMapMethodsService.queryBuilderZoomExtent = true;
                  this.eeService.setAssetViewer(false);
                  this.eeService.setAssetTable(false);
                  Swal.fire("No matching records");
                }
              } else {
                let selectedData: ILayerSelections[] = [];
                visLayersSelectedData.forEach((selected) => {
                  if (selected.length > 0) {
                    this.eeService.formatVisualizationData(selected).forEach((data) => {
                      selectedData.push(data);
                    });
                  }
                });
                this.visLayerQueryResults = this.selectedSet = selectedData;
                this.data.emit(selectedData);

                if (selectedData.length > 0) {
                  this.eeService.setSelectedFeaturesOnMap(selectedData);
                  if (selectedData.length > 0) {
                    //Select Visualization assets
                    this.eeService.setVisualizationAssetViewer(selectedData);
                    this.showCardViewForVisualizationLayer = true;
                    //Added for visualization layers
                    this.reportValueDropdown = [];
                    this.reportValueDropdown.push( {value: this.selectedVisualizationlyr + " Reference Data", display: this.selectedVisualizationlyr + " Reference Data" });
                    this.reportTypeES = this.reportValueDropdown[0].value;
                  }
                  this.eeService.setSelectedFeaturesOnMap(selectedData);
                  this.genericMapMethodsService.queryBuilderZoomExtent = true;
                  this.eeService.setAssetViewer(true);
                  this.eeService.setAssetTable(false);
                  //Add distance join type
                  if (this.joinTypeDropdown.length == 2) {
                    this.joinTypeDropdown.push(this.distanceDropdown); //Added for visualization layers ... add Distance join type
                  }
                } else {
                  this.eeService.setAssetViewer(false);
                  this.eeService.setAssetTable(false);
                  Swal.fire("No matching records");
                }
              }
            }
          );
        }
      } else {
        this.querytableUpdated = this.builtQuery;
        let visualizationLayers = this.layerDropdown.filter((e) => e.isVisualizationLayer == true).map((e) => e.value);
        if (
          this.builtQuery.find((e) => visualizationLayers.includes(e.layer)) &&    // is this not two opposite statements, so always false?
          this.builtQuery.find((e) => !visualizationLayers.includes(e.layer))
        ) {
          //filter visualization layer results
          this.filterVisualizationData = true;
          //filter query table inputs for asset data
          let isAssetQuery = false;
          this.builtQuery.forEach((query) => {
            if (query.joinType && query.joinType.includes("WITHIN")) {
              isAssetQuery = true;
            }
            if (isAssetQuery) {
              query.joinType = "";
              this.querytableUpdated.push(query);
            }
          });
        }

        this.asstClicked = false;
        this.sqlViewOnMap = false;

        if (this.multiplePrimaryLayerQuery && this.multiplePrimaryLayerQuery.queryId && (this.multiplePrimaryLayerQuery.queryId === "QRY_10" || this.multiplePrimaryLayerQuery.queryId === "QRY_11")) {
          // don't think ever get here -- except from obsolete Query Creator and a couple old predefined queries that no one uses anymore
          this.buildQueryMultiple();
          return;
        }

        this.selectionGraphicsLyr = this.map.getLayer("sms-selection");
        this.selectionGraphicsLyr.clear();

        if (this.joinTypeDropdown.length == 3) {
          this.joinTypeDropdown.splice(2, 1); //Added for visualization layers ... remove Distance join type
        }

        // clear selection and reset before executing new query
        this.selectedSet = [];
        this.eeService.setSelectedFeaturesOnMap(this.selectedSet);
        this.data.emit(this.selectedSet);   // emit data to component parent
        // this.eeService.setAssetViewer(true);
        this.eeService.setAssetTable(false);
        this.genericMapMethodsService.queryBuilderZoomExtent = true;
        this.showCardViewForVisualizationLayer = false;

        if (this.selectedQueryLayersList.includes("Sign")) {
          this.eeService.toggleCardView("Sign");
        } else if (this.selectedQueryLayersList.includes("Light")) {
          this.eeService.toggleCardView("Light");
        } else {
          this.eeService.toggleCardView("Others");
        }

        if (this.builtQuery.length === 0) {
          this.addItem(); // auto add statement (first only) from builder if user has not
        } 
        if (this.builtQuery[0]?.joinType != "") {   // gets through occasionally when editing built query
          this.joinType = "";
          //Swal.fire(this.translateService.instant("Querybuilder.alertquery.querycannotstartwithjointype"));
        }

        // run query
        const queryString = this.qbService.createQueryString(this.querytableUpdated, this.currentUser);
        //console.log(`Query string for QB ${queryString}`);
        this.genericLayerService.getQueryResults(queryString, "test").subscribe((results: any) => {

          // results structure  --- 10/11/26 todo fix API inconsistency
          //   {table: [ {objectid: "#"}, ..., ]   -- single layer query result does not include layerName and includes 'objectid' with each value instead of comma sep list
          //   {table: [ {layerName: "<layer name>", objectid: "#, #, ..."}, ...]}   -- multilayer query
          //   {table: [ {error: "<error message>"}]}  (e.g., unsupported query, table is not authorized)

          if (results?.table?.length>0 && results.table[0].error) {
            Swal.fire(this.translateService.instant("Querybuilder.alertquery.erroroccurred", { error: results.table[0].error }));
            return;
          }
          if (results?.table?.length > 0 && results.table[0].layerName) {
            this.processQueryResultsMultipleLayers(results);
          } else {
            this.processQueryResults(results);
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  processQueryResults(results: any) {
    try {

      if ( !(results?.table?.length > 0) ) {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.norecordsfound"));
        return;
      } else if (["Activity", "Assessment", "Maintenance"].includes(this.builtQuery[0].layer)) {
        this.buildQueryMultiple();
        return;
      }
      
      const objectIds: number[] = results.table.map((v) => v.objectid);
      const queryLayerName = ['Sign', 'Light'].includes(this.builtQuery[0].layer) ? "Support" : this.builtQuery[0].layer;
      const queryLayer = this.layerDropdown.find((lyr) => lyr.value === queryLayerName)!;

      /*Select Features on Map*/
      this.loading = true;
      const query = new this.Query();
      query.objectIds = objectIds;
      this.map.graphics.clear();

      if (this.chkMapExtent) { query.geometry = this.map.extent; }

      queryLayer.lyrObj.selectFeatures(
        query,
        this.selectbehaviorobj,
        (queriedFeatures) => {

          let filteredFeatures: any[];
          // filter previously selected features based on selection behavior: new (replace), add to, remove from.  
          // selection behavior is not implmented in UI and defaults to new.
          if (this.selectbehaviorobj === 5) {
            filteredFeatures = this.prevSelected.filter((r) => !objectIds.includes(r.attributes.OBJECTID));
          } else if (this.selectbehaviorobj === 4) {
            let checkAlready;

            if (this.prevSelected && this.prevSelected.length > 0) {
              checkAlready = this.prevSelected.filter((p) => !objectIds.includes(p.attributes.OBJECTID));
              filteredFeatures = this.prevSelected.concat(checkAlready);
            } else {
              filteredFeatures = queriedFeatures;
            }
          } else {
            filteredFeatures = queriedFeatures;
          }

          this.loading = false;

          if (filteredFeatures.length === 0) {
            Swal.fire(this.translateService.instant("Querybuilder.alertquery.noresultfound"));
            //this.isResultPresent = false;
            return;
          }

          this.prevSelected = filteredFeatures;

          if (this.chkMapExtent) {
            filteredFeatures.forEach((asset) => {
              this.selectedObjIdsByMapExtent.push(asset.attributes.OBJECTID);
            });
          } else { 
            this.selectedObjIdsByMapExtent = [];
          }


          //this.layr = this.inventoryLayersData.find((l) => l.name === this.activeLayer.value);

          this.showDataOnMap(queryLayerName, filteredFeatures); //this.activeLayer.lyrObj

        },
        (error) => {
          Swal.fire(this.translateService.instant("Querybuilder.alertquery.invalidquery"));
          this.loading = false;
          return;
        }
      );
    } catch (error) {
      console.error(error);
    }
  }
  processQueryResultsMultipleLayers(results: any) {
    this.buildQueryMultiple();
  }

  setThis() {
    return this;
  }

  buildQueryMultiple() {
    try {

      if (this.multiplePrimaryLayerQuery) {
        const regionStatement = "Region" + this.currentUser.selectedRegion.regionLevel + "='" + this.currentUser.selectedRegion.regionName + "' AND";

        if (this.multiplePrimaryLayerQuery.queryId === "QRY_11" || this.multiplePrimaryLayerQuery.queryId === "QRY_10") {
          // special queries, built early on in development, with multiple primary layers. This type of query cannot be built with Query Builder.
          this.qbService
            .executeMultiplePrimaryLayers(
              event,
              regionStatement,
              this.multiplePrimaryLayerQuery,
              this.layerDropdown,
              this.Query,
              this.FeatureLayer,
              this.map,
              this.SimpleMarkerSymbol,
              this.SimpleLineSymbol,
              this.SimpleFillSymbol,
              this.Color,
              this.Graphic
            )
            .then((result) => {
              //Added for visualization layers
              if (!this.filterVisualizationData || !this.visLayerQueryResults || this.visLayerQueryResults.length == 0) {
                this.data.emit(result);
                //Manikantha V 2/8/2021
                this.eeService.setSelectedFeaturesOnMap(result);
                // Added by Madhuri Gupta for JIRA ID:-62 on 08/03/2021
                this.genericMapMethodsService.queryBuilderZoomExtent = true;
                console.log(4);

                if (this.selectedQueryLayersList.includes("Sign")) {
                  this.eeService.toggleCardView("Sign");
                } else if (this.selectedQueryLayersList.includes("Light")) {
                  this.eeService.toggleCardView("Light");
                } else {
                  this.eeService.toggleCardView("Others");
                }

                this.eeService.setAssetViewer(true);
                this.eeService.setAssetTable(false);
                //Added for Visualization layers
                this.showCardViewForVisualizationLayer = false;
                console.log("Grid View Close  " + 4);
              }
            });
          return;
        }
      }

      this.selectedSet = [];
      if (this.joinTypeDropdown.length == 3) {
        this.joinTypeDropdown.splice(2, 1); //Added for visualization layers ... remove Distance join type
      }
      if (this.builtQuery.length === 0) {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.addquerytoexecute"));
        return;
      } else if (this.builtQuery.length === 1 && this.builtQuery[0].joinType != "") {
        this.builtQuery[0].joinType = "";
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.querycannotstartwithjointype"));
      } else {
        // Get QueryString to fetch Data
        const queryString = this.qbService.createQueryString(this.querytableUpdated, this.currentUser);
        const functionname = "test";

        const allResults = [];

        this.genericLayerService.getQueryResults(queryString, functionname).subscribe(
          function (results: any) {             // results = object with 'table' property containing array of objects, representing 
                                                // each asset layer (spatial and/or child) that has records returned by the query. 
                                                // the asset layer objects have 2 string properties: 
                                                //    layerName
                                                //    objectid - comma separated list of objectIds for selected assets
                                                //                or in the case of child assets, their parent objectIds
            const query = new this.Query();
            const allLayersObj = [];
            results.table.forEach((resTable) => {

              const lyrName = (["Sign", "Light", "Support"].includes(resTable.layerName)) ? "Support" : resTable.layerName;  // 7/27/20 jcc the objects list returned for Signs and Lights by getQueryResults are the parent (Support) record's ObjectIds.              
              this.layr = this.inventoryLayersData.find((l) => l.name === lyrName);
              
              const objectIds = resTable.objectid.split(",").map( (item) => { return parseInt(item, 10) });

              //if (resTable.layerName === "Sign" || resTable.layerName === "Light" || resTable.layerName === "Support") {
              if (lyrName === "Support") {
                const lyrSupportData = allLayersObj.filter((lyr) => lyr.LayerObj === this.layr);

                if (lyrSupportData.length > 0) {
                  const obj = lyrSupportData[0].ObjectID.concat(objectIds); 
                  allLayersObj.find((lyr) => lyr.LayerObj === this.layr).ObjectID = obj;
                } else {
                  if (this.layr.visible) {
                    // 7/27/20 jcc only keep layers that are currently visible
                    allLayersObj.push({
                      LayerObj: this.layr,        // 9/28/26 this should be the ILayer version of this layer
                      ObjectID: objectIds
                    });
                  }
                }
              } else {
                if (this.layr) {
                  if (this.layr.visible) {
                    // 7/27/20 jcc only keep layers that are currently visible
                    allLayersObj.push({
                      LayerObj: this.layr,
                      ObjectID: objectIds
                    });
                  }
                }
              }
            });
            this.loading = true;
            this.map.graphics.clear();

            /** Check map extent */
            if (this.chkMapExtent) {
              query.geometry = this.map.extent;
            }

            const _this = this.setThis();
            let count = allLayersObj.length;
            allLayersObj.forEach(
              function (layer) {
                query.objectIds = layer.ObjectID;


                layer.LayerObj.lyrObj.selectFeatures(query, this.selectbehaviorobj, (res) => {
                    this.loading = false;
                    if (res.length === 0) {
                      count -= 1;
                      return;
                    }
                    allResults.push({
                      Data: res,
                      LayerInfo: layer.LayerObj
                    });
                    if (allResults.length === count) {
                      this.eeService.setSelectedFeaturesOnMap(allResults);
                      // Added by Madhuri Gupta for JIRA ID:-62 on 08/03/2021
                      this.genericMapMethodsService.queryBuilderZoomExtent = true;
                      this.showDataOnMapMultiple(allResults);
                    }
                  },
                  function (error) {
                    Swal.fire(this.translateService.instant("Querybuilder.alertquery.invalidquery"));
                    this.loading = false;
                    return;
                  }
                );   

              }.bind(this)
            );


          }.bind(this)
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  editItem() {
    try {
      this.queryStatement = {} as IQueryStatement;
      this.queryStatement.layer = this.selectedLayer!.value;
      this.queryStatement.field = this.selectedField;

      if (this.enableDateTimePicker) {
        const formattedDate = this.codedValueControl.value.getMonth() + 1 + "-" + this.codedValueControl.value.getDate() + "-" + this.codedValueControl.value.getFullYear();
        this.queryStatement.value = formattedDate;
      } else {
        if (this.selectedField === "AssetCode") {
          this.qbService.assetCode = this.codedValueControl.value;
        }

        this.queryStatement.value = this.codedValueControl.value;
      }

      this.queryStatement.operator = this.operator;

      if (this.queryStatement.layer && this.queryStatement.field && this.queryStatement.operator && (this.queryStatement.value || this.queryStatement.value == '0') ) {
        if (this.index === 0) {
          if (this.queryStatement.joinType) {
            this.joinType = "";
            Swal.fire(this.translateService.instant("Querybuilder.alertquery.noeditjointypeprimaryquery"));
            return;
          }

          this.queryStatement.joinType = "";
        } else {
          this.queryStatement.joinType = this.joinType;
        }
        this.queryStatement.layerDisplay = this.aliasData.find((alias) => alias.attributes.Name === this.queryStatement.layer).attributes.Alias;
        this.builtQuery[this.index] = this.queryStatement;
        this.isRowClicked = false;
        this.selectedSet = [];
        if (this.joinTypeDropdown.length == 3) {
          this.joinTypeDropdown.splice(2, 1); //Added for visualization layers ... remove Distance join type
        }
      } else {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.entervalues"));
      }
    } catch (error) {
      console.error(error);
    }
  }

  showDataOnMapMultiple(allResults: ILayerSelections[]) {
    try {
      // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
      this.eeService.setEnableSingleClick(false);
      this.selectedSet = allResults;
      this.selectionGraphicsLyr.clear();
      if (this.joinTypeDropdown.length == 2) {
        this.joinTypeDropdown.push(this.distanceDropdown); //Added for visualization layers ... add Distance join type
      }
      this.data.emit(this.selectedSet);    // let eeService do this
      //Manikantha V 2/8/2021
      if (this.selectedQueryLayersList.includes("Sign")) {
        this.eeService.toggleCardView("Sign");
      } else if (this.selectedQueryLayersList.includes("Light")) {
        this.eeService.toggleCardView("Light");
      } else {
        this.eeService.toggleCardView("Others");
      }

      //jcc 8/20/21 add back in define query export reports
      this.reportValueDropdown = this.getReportType();
      this.reportTypeES = this.reportValueDropdown[0].value;

      this.eeService.setAssetViewer(true);
      this.eeService.setAssetTable(false);
      //Added for Visualization layers
      this.showCardViewForVisualizationLayer = false;
      console.log("Grid View Close  " + 7);
      this.loadingQc = false;
      this.loading = false;
    } catch (error) {
      console.error(error);
    }
  }

  getTasksCount(assetID) {
    try {
      // 7/28/20 jcc  - expanded function to retrieve assets that are related to child assets with open tasks.
      return new Promise(
        function (resolve) {
          const query = new this.Query();
          const queryTaskMaintenance = new this.QueryTask(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.maintenanceId);
          const queryTaskSign = new this.QueryTask(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.signId);
          query.outFields = ["AssetID"];

          // get asset open tasks
          query.where = "AssetID='" + assetID + "' AND Status='Open'";
          queryTaskMaintenance.execute(query).then((result) => {
            if (result.features.length > 0) {
              resolve(result.features.length); // primary asset has open maintenance.  stop here since actual count of tasks does not seem necessary.
            } else {
              // get sign asset children of selected assets
              const childAssetIDList = [];
              query.where = "ParentID='" + assetID + "' AND Status <> 'Inactive'";
              queryTaskSign.execute(query).then((result) => {
                if (result.features.length > 0) {
                  result.features.forEach((element) => {
                    childAssetIDList.push("'" + element.attributes.AssetID + "'");
                  });

                  // get children's open maintenance
                  query.where = "AssetID IN (" + childAssetIDList.toString() + ") and Status = 'Open'";
                  queryTaskMaintenance.execute(query).then((result) => {
                    resolve(result.features.length); // count (zero or more) of child assets with open maintenance
                  });
                } else {
                  resolve(0); // neither primary or related assets have an open task
                }
              });
            }
          });
        }.bind(this)
      );
    } catch (error) {
      console.error(error);
    }
  }

  showDataOnMap(queryLayerName:string, selectedFeatures:any[]) {
    try {
      // Added by Madhuri Gupta for JIRA ID:-35 on 07/29/2021
      this.eeService.setEnableSingleClick(false);
      this.selectionGraphicsLyr = this.map.getLayer("sms-selection");
      this.selectionGraphicsLyr.clear();
      this.selectedSet = [];

      const lyr: ILayer = this.qbService.getLayerInfo().find((layer) => layer.name === queryLayerName) as ILayer;

      this.selectedSet.push({ LayerInfo: lyr, Data: selectedFeatures });
      if (this.joinTypeDropdown.length == 2) {
        this.joinTypeDropdown.push(this.distanceDropdown); //Added for visualization layers ... add Distance join type
      }
      if (!this.sqlViewOnMap) {
        this.reportValueDropdown = this.getReportType();
        this.reportTypeES = this.reportValueDropdown[0].value;
      }
      this.isFromQB.emit(true);
      this.data.emit(this.selectedSet);
      if (this.selectedSet[0].Data.length == this.map.smsLayerdata.dynamicMapLayer.maxRecordCount) {
        this.qbService.updateMaxRecordMessage(this.map.smsLayerdata.dynamicMapLayer.maxRecordCount);
      }
      //Manikantha V 2/8/2021
      this.eeService.setSelectedFeaturesOnMap(this.selectedSet);  // 
      // Added by Madhuri Gupta for JIRA ID:-62 on 08/03/2021
      this.genericMapMethodsService.queryBuilderZoomExtent = this.chkMapExtent ? false : true;  //4/3/26 don't change extent when using current extent for query
      console.log(8);

      if (this.selectedQueryLayersList.includes("Sign")) {
        this.eeService.toggleCardView("Sign");
      } else if (this.selectedQueryLayersList.includes("Light")) {
        this.eeService.toggleCardView("Light");
      } else {
        this.eeService.toggleCardView("Others");
      }

      this.eeService.setAssetViewer(true);
      this.eeService.setAssetTable(false);
      //Added for Visualization layers
      this.showCardViewForVisualizationLayer = false;
      console.log("Grid View Close  " + 10);
      this.loadingQc = false;
    } catch (error) {
      console.error(error);
    }
  }
  saveQuery(queryTool) {
    try {
      if (this.fileName == null || this.fileName === "") {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.enternameb4saving"));
        this.clickedOnSave = true;
        return;
      }

      /*Validate if file Name already present*/
      let validateFileName=[];
      let queryString;

      if (queryTool === "QB") {
        this.clickedOnSave = false;
        validateFileName = this.savedQueriesList.filter((savedQuery) => savedQuery.fileName === this.fileName);

        if (this.builtQuery.length === 0) {
          Swal.fire(this.translateService.instant("Querybuilder.alertquery.enterqueryb4saving"));
          this.clickedOnSave = true;
          return;
        }

        queryString = this.qbService.createQueryString(this.builtQuery, this.currentUser);
      } else if (queryTool === "QC") {
        this.clickedOnSave = false;
        this.vaildateQuery();

        if (this.sqlResultCount > 0) {
          validateFileName = this.sqlgetSavedQueries.filter((savedQuery) => savedQuery.fileName === this.fileName);
          queryString = this.createdQuery;
        }
      }

      if (validateFileName.length > 0) {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.noduplicatequery"));
        this.clickedOnSave = true;
        return;
      }

      this.qbService.saveQuery(this.fileName, this.FeatureLayer, queryString, this.Graphic, queryTool, null).then(
        (result) => {
          this.savedQueriesList = this.getSavedQueries("QB");

          if (this.sqlResultCount > 0) {
            this.sqlgetSavedQueries = this.getSavedQueries("QC");
          }

          Swal.fire(this.translateService.instant("Querybuilder.alertquery.querysavetodatabase"));
          this.clickedOnSave = true;
        }
      );
    } catch (error) {
      console.error(error);
    }
  }
  /** Delete saved query from database */
  deleteQuery(queryTool: string) {
    try {
      if (this.fileName == null || this.fileName === "") {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.enternametodelete"));
        return;
      }

      let checkFilePresent=[];

      if (queryTool === "QB") {
        checkFilePresent = this.savedQueriesList.filter((list) => list.fileName === this.fileName);
      } else if (queryTool === "QC") {
        checkFilePresent = this.sqlgetSavedQueries.filter((list) => list.fileName === this.fileName);
      }

      if (checkFilePresent.length <= 0) {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.querynamenotavailable"));
        return;
      }

      let deleteRecord: any;
      const _this = this.setThis();
      this.qbService.deleteQuery(this.FeatureLayer, this.fileName, this.Query, this.QueryTask, queryTool).then( (result) => {
        if (result) {
          deleteRecord = result;

          if (deleteRecord.length === 0) {
            Swal.fire(this.translateService.instant("Querybuilder.alertquery.noquerynameavailable"));
            return;
          }

          _this.queryLayersService.deleteAsset(this.userQueryActionsLyrObj, deleteRecord.features[0]).then((result) => {
            if (result) {
              Swal.fire(_this.translateService.instant("Querybuilder.alertquery.successfullydeleted"));
              _this.savedQueriesList = _this.getSavedQueries("QB");
              _this.sqlgetSavedQueries = _this.getSavedQueries("QC");
              _this.builtQuery = [];
              _this.fileName = "";
              _this.createdQuery = "";
            }
          });
        }
      });
    } catch (error) {
      console.error(error);
    }
  }
  /** Load from Database into Map */
  populateQueryTable(selectedFile, queryTool) {
    try {
      if (queryTool === "QB") {
        this.builtQuery = [];
        this.selectedSet = [];
        if (this.joinTypeDropdown.length == 3) {
          this.joinTypeDropdown.splice(2, 1); //Added for visualization layers ... add Distance join type
        }
        const queryStringSelected = this.savedQueriesList.filter((savedQuery) => savedQuery.fileName === this.selectedLoadFile);
        this.parseQuery(queryStringSelected);
        // Get Layer Name
        let layer = queryStringSelected[0].queryString.split("?")[0].split(":")[0];
        let primaryLayer;

        if (["Activity", "Assessment", "Maintenance", "Sign", "Light"].includes(layer)) {
          primaryLayer = layer;
          layer = "Support";          /// this doesn't seem right
        }

        this.qbService.getLayerListDropdownValues(layer);

      } else if (queryTool === "QC") {
        const queryStringSelected = this.sqlgetSavedQueries.filter((savedQuery) => savedQuery.fileName === selectedFile);

        if (queryStringSelected.length === 0) {
          Swal.fire("Incorrect Query Saved");
        } else {
          this.createdQuery = queryStringSelected[0].queryString;
          this.fileName = queryStringSelected[0].fileName;
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  /** Save Query Table to Text File */
  saveQueryAsFile() {
    try {
      if (this.builtQuery.length <= 0) {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.addqueryb4savingtofile"));
      } else {
        const data = this.qbService.createQueryString(this.builtQuery, this.currentUser);
        this.qbService.saveTextAsFile(data, "queryToFile.txt");
      }
    } catch (error) {
      console.error(error);
    }
  }

  /** Load Query from text file to querytable */
  loadTextAsQuery(event) {
    try {
      this.qbService.loadTextAsQuery(event).then((result) => {
        this.parseQuery(result);
        // Get Layer Name
        let layer = result[0].queryString.split("?")[0].split(":")[0];
        let primaryLayer;
        if (["Activity", "Assessment", "Maintenance", "Sign", "Light"].includes(layer)) {
          primaryLayer = layer;
          layer = "Support";
        }
        this.qbService.getLayerListDropdownValues(layer);
      });
    } catch (error) {
      console.error(error);
    }
  }

  parseQuery(queryStringSelected) {
    try {
      this.builtQuery = [];

      try {
        const queryString = queryStringSelected[0].queryString;
        this.fileName = queryStringSelected[0].fileName;
        let queries = [];
        queries = queryString.split("?");
        const layers = queries[0].split(":");
        const clauses = queries[1].split(";");
        //const count_tables = 0;

        this.disableJoinTypeDropdown = false;
        for (let i = 1; i < clauses.length; i++) {
          this.queryStatement = {} as IQueryStatement;
          const conditionSplit = clauses[i].trim().split(" ");

          if (conditionSplit.length === 3) {
            const tablePrefix = conditionSplit[0].split(".")[0];
            this.queryStatement.layer = this.constants.getQueryTables(tablePrefix, layers[0]);
            const fieldName = conditionSplit[0].split(".");
            this.selectedLayerFieldAliases = this.onFieldChange(fieldName[1]);
            this.queryStatement.field = fieldName[1];
            const match = this.aliasData.find((alias) => alias.attributes.Name === this.queryStatement.layer);
            this.queryStatement.layerDisplay = this.aliasData.find((alias) => alias.attributes.Name === this.queryStatement.layer).attributes.Alias;
            this.queryStatement.operator = conditionSplit[1];
            this.queryStatement.value = conditionSplit[2].replace(/'/g, "");
          } else {
            const tablePrefix = conditionSplit[1].split(".")[0];
            this.queryStatement.layer = this.constants.getQueryTables(tablePrefix, layers[0]);
            const match = this.aliasData.find((alias) => alias.attributes.Name === this.queryStatement.layer);
            this.queryStatement.layerDisplay = this.aliasData.find((alias) => alias.attributes.Name === this.queryStatement.layer).attributes.Alias;
            //jcc 10/1/20 -- account for space(s) in Value, which cause conditionSplit.length>3.
            //              Original code assumed this necessarily meant a statement with a Join -- error if first statement in query.
            //              Original code truncated the Value at first space when loading saved queries.
            if (conditionSplit[0] == "AND" || conditionSplit[0] == "OR") {
              this.queryStatement.joinType = conditionSplit[0];
            } else {
              // placeholder so remaining code works as expected
              conditionSplit.unshift("");
            }

            if (conditionSplit.length > 4) {
              //jcc 10/1/20 -- re-concat any space seperated components of Value
              for (let j = 4; j < conditionSplit.length; j++) {
                conditionSplit[3] += " " + conditionSplit[j];
              }
            }

            const fieldName = conditionSplit[1].split(".");
            this.selectedLayerFieldAliases = this.onFieldChange(fieldName[1]);
            this.queryStatement.field = fieldName[1];
            this.queryStatement.operator = conditionSplit[2];
            this.queryStatement.value = conditionSplit[3].replace(/'/g, "");
          }

          this.builtQuery.push(Object.create(this.queryStatement));
        }
      } catch (err) {
        if (err) {
          Swal.fire(this.translateService.instant("Querybuilder.alertquery.invalidformat"));
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  /**Reports Functions */
  getReportType() {
    return this.qbService.getReportValues(this.selectedSet);
  }
  onChangeReportType(event) {
    try {
      this.reportTypeES = event;
      if (this.selectedLayer?.isVisualizationLayer) {
        let data = [];
        let tableBody;
        if (!this.reportTypeES.includes("Reference Data") && this.selectedSet && this.selectedSet.length > 0) {
          //Asset layers
          this.selectedSet[0].Data.forEach((asset: any) => {
            data.push(asset.attributes);
          });
          tableBody = this.qbService.createTableBodyForVisualizationLayers(data, false);
        } else if (this.reportTypeES.includes("Reference Data") && this.visLayerQueryResults) {
          //Visualization layers
          this.visLayerQueryResults[0].Data.forEach((row) => {
            data.push(row.attributes);
          });
          tableBody = this.qbService.createTableBodyForVisualizationLayers(data, true);
        }

        let dataLength = data.length;
        this.qbService.reports(tableBody, this.reportFormatES, this.reportTypeES, dataLength, pdfMake);
      } else {
        this.selectedReportType = event;
        let functionName = "Report:";
        const data = this.qbService.createQueryString(this.builtQuery, this.currentUser);
        functionName += this.constants.getLayerNameFromReportName(event) ?? this.selectedLayer!.value;
        const _this = this.setThis();
        let reportData = "";

        if (this.chkMapExtent) {
          reportData = data.split("?")[0] + "?" + "OBJECTID in (" + this.selectedObjIdsByMapExtent.join(",") + ")";
        } else {
          reportData = data;
        }

        this.genericLayerService.getQueryResults(reportData, functionName).subscribe((results: any) => {
          if (results) {
            _this.tableBody = this.qbService.createTableBody(results.table);
            _this.dataLength = results.table.length;

            if (this.firstReport) {
              this.qbService.reports(this.tableBody, this.reportFormatES, this.selectedReportType, this.dataLength, pdfMake);
            }

            this.firstReport = false;
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
  exportReports() {
    try {
      this.tableBody = undefined;

      if (this.tableBody === undefined) {
        this.firstReport = true;
        this.onChangeReportType(this.reportTypeES);
      }
    } catch (error) {
      console.error(error);
    }
  }
  vaildateQuery() {
    try {
      let layer: any;

      if (this.createdQuery === "" || this.createdQuery == null) {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.enterqueryb4validate"));
        return;
      }

      if (this.createdQuery.includes("--")) {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.commentnorallowed"));
        return;
      }

      try {
        layer = this.createdQuery.toLocaleLowerCase().split("from")[1].split(" ")[1];

        if (this.createdQuery.includes("*") && ["Activity", "Assessment", "Maintenance"].includes(layer)) {
          Swal.fire(this.translateService.instant("Querybuilder.alertquery.addassetidincolumn"));
          return;
        }
      } catch (err) {
        Swal.fire("Invalid Query");
      }

      if (layer.toLocaleLowerCase() === "sign" || layer.toLocaleLowerCase() === "light") {
        layer = "support";
      }

      const isAllowed = this.layerDropdown.filter((lyr) => lyr.value.toLowerCase() === layer.toLocaleLowerCase());

      if (isAllowed.length <= 0) {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.layernotaccessible"));
        return;
      }

      const functionName = "QueryCreatorValidate";
      const params = this.createdQuery;
      this.genericLayerService.getQueryResults(params, functionName).subscribe(
        (results: any) => {
          if (results) {
            if (results.table[0].error) {
              Swal.fire(results.table[0].error);
              this.queryValidatedFromServer = false;
            } else {
              this.sqlResultCount = results.table[0].count;

              if (this.sqlResultCount === 0) {
                Swal.fire("No records Found");
                return;
              }

              this.queryValidatedFromServer = true;
            }
          } else {
            Swal.fire(this.translateService.instant("Querybuilder.alertquery.errorinquery"));
            return;
          }

          if (this.queryValidatedFromServer) {
            this.clickedValidate = true;
            setTimeout(() => {
              this.clickedValidate = false;
              this.queryValidatedFromServer = false;
            }, 15000);
          }
        },
        (err) => {
          Swal.fire(err.error.error.message);
          return;
        }
      );
    } catch (error) {
      console.error(error);
    }
  }
  clearQuery() {
    this.createdQuery = "";
    this.sqlResultCount = 0;
    this.fileName = "";
    this.sqlgetSavedQueries = this.getSavedQueries("QC");
    this.showCardViewForVisualizationLayer = false;
  }

  runQuery() {  // only called by Query Creator (no longer implemented)
    try {
      let functionName = "QueryCreator";
      this.sqlResultCount = 0;

      if (! (this.sqlViewOnMap || this.sqlViewOnExcel)) {
        Swal.fire(this.translateService.instant("Querybuilder.alertquery.selectoptionfrresults"));
        return;
      } else {

        if (this.sqlViewOnExcel === true) { functionName += "Export"; }
        if (this.sqlViewOnMap === true) { functionName += "Load"; }

        this.clickedRun = true;
        setTimeout(() => {
          this.clickedRun = false;
        }, 15000);

        let queryAttempt = Number(localStorage.getItem("queryAttempts"));
        if (queryAttempt === 50) {
          Swal.fire(this.translateService.instant("Querybuilder.alertquery.exceednumberqueries"));
          return;
        }

        this.loadingQc = true;
        queryAttempt += 1;
        localStorage.setItem("queryAttempts", queryAttempt.toString());
        this.createdQuery = this.createdQuery.toLocaleLowerCase();
        const mapObj = {
          assetid: "assetID",
          parentid: "parentID"
        };
        this.createdQuery = this.createdQuery.replace(/assetid|parentid/gi, function (matched) {
          return mapObj[matched];
        });
        const params = this.createdQuery;
        const _this = this.setThis();
        this.genericLayerService.getQueryResults(params, functionName).subscribe( (results: any) => {
          this.countWhere = 0;

          if (results && results.table.length) {
            console.log(results);

            if (this.sqlViewOnExcel) {
              const tablebody = _this.qbService.createTableBodySQL(results.table);
              this.qbService.reports(tablebody, "Microsoft Excel", "", this.sqlResultCount, pdfMake);
              this.loadingQc = false;
            }

            if (this.sqlViewOnMap) {
              let layer = this.createdQuery.toLocaleLowerCase().split("from")[1].split(" ")[1];
              const origLayer = layer;

              if (layer.toLocaleLowerCase() === "sign" || layer.toLocaleLowerCase() === "light") {
                layer = "support";
              }

              if (['maintenance', 'assessment', 'activity'].includes(layer.toLocaleLowerCase())) {
                const allResults = [];
                let filteredResults = [];
                // Iteration thrugh all primary and related layers
                const reqdLayers = this.layerDropdown.filter((l) => l.value.toLocaleLowerCase() !== "maintenance" && l.value.toLocaleLowerCase() !== "assessment" && l.value.toLocaleLowerCase() !== "activity");
                if (reqdLayers.filter((lyr) => lyr.value === "Sign").length > 0) {
                  //length -= 2;
                }

                reqdLayers.forEach((lyr) => {
                  results.table.filter((res) => {
                    if (res.assetID != null) {
                      if (res.assetID.slice(0, 3) === this.assetDetailService.assetFormatCodes.filter((res) => res.attributes.Name === lyr.value)[0].attributes.LayerCode) {
                        filteredResults.push(res);
                      }
                    }
                  });
                  const query = new this.Query();
                  let assetID = "";
                  filteredResults.forEach((object) => {
                    if (filteredResults.length > 0) {
                      if (object.parentid) {
                        assetID += "'" + object.parentid + "'.";
                      } else {
                        assetID += "'" + object.assetID + "',";
                      }
                    }
                  });

                  if (assetID === "") {
                    // Swal.fire(this.translateService.instant('Querybuilder.alertquery.addassetidincolumn'));
                    // this.loadingQc=false;
                    // return;
                  } else {
                    query.where = "AssetID in (" + assetID.substring(0, assetID.length - 1) + ")";

                    if (lyr.value.toLocaleLowerCase() !== "sign" && lyr.value.toLocaleLowerCase() !== "light") {
                      this.countWhere++;
                    }
                  }

                  const queryLayerName = ['Sign', 'Light'].includes(lyr.value) ? "Support" : this.builtQuery[0].layer;
                  const queryLayer = this.layerDropdown.find((l) => l.value === queryLayerName)!;

                  if (query.where) {
                    queryLayer.lyrObj.selectFeatures(
                      query,
                      queryLayer.lyrObj.NEW_SELECTION,
                      (result) => {
                        if (result && result.length > 0) {
                          const existingsupportLayer = allResults.filter((res) => res.layerObj === queryLayer.lyrObj);

                          if (existingsupportLayer.length > 0) {
                            const data = existingsupportLayer[0].Data.concat(result);
                            allResults.find((lyr) => lyr.layerObj === queryLayer.lyrObj).Data = data;
                          } else {
                            allResults.push({
                              Data: result,
                              layerObj: queryLayer.lyrObj,
                              layerData: queryLayer          // double-check what this is trying to do
                            });
                          }

                          if (allResults.length === this.countWhere) {
                            this.showDataOnMapMultiple(allResults);
                            this.loadingQc = false;
                          }
                        }
                      }
                    );
                  }

                  filteredResults = [];
                });
                this.loadingQc = false;
                //return;
              } else {
                const layerObj = this.layerDropdown.find((astCls) => astCls.value.toLowerCase() === layer.toLocaleLowerCase())!;
                console.log(layerObj);
                const query = new this.Query();
                query.objectIds = [];
                //const oid = [];
                let assetID = "";
                results.table.forEach( (r) => {
                  if (r.objectid && origLayer.toLocaleLowerCase() !== "sign" && origLayer.toLocaleLowerCase() !== "light") {
                    query.objectIds.push(r.objectid);
                  } else {
                    if (origLayer.toLocaleLowerCase() === "sign" || origLayer.toLocaleLowerCase() === "light") {
                      if (r.parentID) {
                        assetID += "'" + r.parentID + "',";
                      } else if (r.parentid) {
                        assetID += "'" + r.parentid + "',";
                      }
                    } else {
                      if (r.assetID) {
                        assetID += "'" + r.assetID + "',";
                      } else if (r.assetid) {
                        assetID += "'" + r.assetid + "',";
                      }
                    }
                  }
                });

                if (query.objectIds.length === 0) {
                  query.where = "AssetID in (" + assetID.substring(0, assetID.length - 1) + ")";
                }

                layerObj.lyrObj.selectFeatures(query, layerObj.lyrObj.NEW_SELECTION, (result) => {
                  if (result && result.length > 0) {
                    _this.showDataOnMap(layerObj.value, result);
                    _this.loadingQc = false;
                  } else {
                    Swal.fire("Data not present in current region");
                  }

                  _this.loadingQc = false;
                });
                console.log(results);
              }
            }
          } else {
            Swal.fire(this.translateService.instant("Querybuilder.alertquery.invalidquery"));
        }},
          (err) => {
            if (err) {
              Swal.fire(this.translateService.instant("Querybuilder.alertquery.queryincorrectrecheck"));
            }
          }
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  onTextAreaChange(event) {
    console.log("Text Area Change", event);
    this.queryValidatedFromServer = false;
  }
  InfoMessage() {
    let text = '<div class="text-left py-4"><b>Validate :</b> Considers all the regions available</div>';
    text += '<div class="text-left"><b>Run (' + this.translateService.instant("Querybuilder.predefinedquery.loadreturnedassets") + "):</b>  Results will be shown on map as per selected region</div>";
    text += '<div class="text-left pt-3"><b>Run (Export results to CSV):</b>  Results will be for all regions</div>';

    Swal.fire({
      type: "info",
      title: "",
      html: '<div class="text-center" style="font-size: 15px;">' + text + "</div>",
      width: "465px"
    });
  }
  openCardClicked() {
    this.showCardViewForVisualizationLayer = true;
    this.eeService.setAssetViewer();
    this.eeService.addNewParent = false;
    this.eeService.addNewChild = false;
  }
  openGridClicked() {
    // Asset Table View
    this.eeService.setAssetTable();
  }
  openMaintenanceClicked() {
    this.eeService.setMaintenanceView();
  }

  // JIRA ID:-61
  //Added for visualization layers
  loadVisualizationLayersData(layerName) {
    let fieldsData;
    return new Promise(
      function (resolve) {
        const allFieldsData = [];
        const lyr = this.map.visualizationLayers.find((e) => e.layerName == layerName || e.originalLayerTitle == layerName);
        const url = this.eeService.wfsDescribeFeatureTypeUrl(lyr);
        if (url !== "") {
          allFieldsData.push(this.getSelectedWFSFieldData(url, lyr.originalLayerTitle));       
          this.all(allFieldsData).then(
            function (fieldsInfo) {
              fieldsInfo.forEach((data) => {
                if (data.length > 0) {
                  fieldsData = data;
                }
              });
              resolve(fieldsData);
            }.bind(this)
          );
        }
      }.bind(this)
    );
  }

  getSelectedWFSFieldData(getFeaturesUrl, layerTitle) {
    try {
      return new Promise(
        function (resolve) {
          this.genericLayerService.getWMSLayers(getFeaturesUrl).subscribe(
            (res: any) => {
              let parser = new xml2js.Parser({ trim: true, explicitArray: true });
              if (res) {
                parser.parseString(res, (err, result) => {
                  let fieldData = [];
                  fieldData.push({ class: layerTitle });
                  if (result && result.hasOwnProperty("xsd:schema")) {
                    let complexType = result["xsd:schema"]["xsd:complexType"];
                    if (complexType && complexType[0]) {
                      let complexContent = complexType[0]["xsd:complexContent"];
                      if (complexContent && complexContent[0]) {
                        let extension = complexContent[0]["xsd:extension"];
                        if (extension && extension[0]) {
                          let sequence = extension[0]["xsd:sequence"];
                          if (sequence && sequence[0]) {
                            let elements = sequence[0]["xsd:element"];
                            elements.forEach((element) => {
                              fieldData.push({ name: element["$"].name, type: element["$"].type ? element["$"].type.split(":")[1] : "string" });
                            });
                          }
                        }
                      }
                    }
                  }
                  resolve(fieldData);
                });
              } else {
                resolve([]);
              }
            },
            (err) => {
              console.log(err);
              resolve([]);
            }
          );
        }.bind(this)
      );
    } catch (error) {
      console.error(error);
    }
  }

  private async getWMSFieldInfo(layerName: string) {
    const _this = this.setThis();   //9/28/26 without this is undefined in some async contexts

    if (!_this.visualizationFieldsData.find((f) => f[0]?.class == layerName)) {
      _this.visualizationFieldsData.push(await _this.loadVisualizationLayersData(layerName));
    }

    //get the fields
    const layerOrgName = _this.map.visualizationLayers.find((e) => e.layerName == layerName || e.originalLayerTitle == layerName)?.originalLayerTitle;
    const currentLayerFields = _this.visualizationFieldsData.filter((e) => e[0]?.class == layerOrgName);
    if (currentLayerFields.length > 0 && currentLayerFields[0].length > 0) {
      _this.selectedLayerFieldAliases = [];
      currentLayerFields[0].forEach((f) => {
        if (!f.class && f.name.toLowerCase() != "shape") {
          _this.selectedLayerFieldAliases.push({ Field: f.name, FieldAlias: f.name, FieldAlias_SL: f.name });
        }
      });
      _this.fieldDropdown = _this.selectedLayerFieldAliases.map((field) => {
        const dropdownItem: IDropdownListItem = {} as IDropdownListItem;
        dropdownItem.display = _this.currentUser.scndLang == false ? field.FieldAlias : field.FieldAlias_SL;
        dropdownItem.value = field.Field;
        return dropdownItem;
      });
    } else {
      Swal.fire("No records found");
      _this.emptySearchFields();
    }
  }

  private _filter(value: string): IDropdownListItem[] {
    if (value != null) {
      const filterValue = value.toLowerCase();

      const filteredValues = this.codedValues.filter((option) => (option.code + " " + option.name).toLowerCase().includes(filterValue));

      return [...new Map(filteredValues.map((item) => [item["name"], item])).values()];
    }
    return [...new Map(this.codedValues.map((item) => [item["name"], item])).values()];
  }
  
  //TSDRSAM-1805 : getting selected report format
  onChangeReportFormat(event) {
    this.reportFormatES = event;
  }

  uniq(a) {
    return a.filter((value, index, self) => index === self.findIndex((t) => t.place === value.place && t.name === value.name));
  }
  //
}
